/** Meme 时间信息来源类型 */
export type TMemeTimeType = 'hot' | 'first_seen';

export interface IMemeTimeInfo {
  time: string | undefined;
  type: TMemeTimeType;
  /** i18n key，如 'Hot Time'、'First Seen' */
  labelKey: string;
  /** 是否显示 'Before {time}' 前缀 */
  withPrefix: boolean;
}

/**
 * 根据渠道判断 Meme 时间展示逻辑
 * - bilibili: 展示 hottest_time (Hot Time)，无前缀
 * - tiktok: 展示 hottest_time (Hot Time)，无前缀
 * - 其他: 展示 min_release_time (First Seen)，带 Before 前缀
 */
export function getMemeTimeInfo(
  channels: string[] | undefined,
  hottestTime: string | undefined,
  minReleaseTime: string | undefined,
): IMemeTimeInfo | null {
  if (!channels) return null;
  if (channels.includes('tiktok') || channels.includes('bilibili')) {
    return { time: hottestTime, type: 'hot', labelKey: 'Hottest Time', withPrefix: false };
  }
  return { time: minReleaseTime, type: 'first_seen', labelKey: 'First Seen', withPrefix: true };
}
